import { render, staticRenderFns } from "./SingUpForm.vue?vue&type=template&id=709d92ac"
import script from "./SingUpForm.vue?vue&type=script&lang=js"
export * from "./SingUpForm.vue?vue&type=script&lang=js"
import style0 from "./SingUpForm.vue?vue&type=style&index=0&id=709d92ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports